import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const categories = ['All', 'Lakefront Homes', 'Saint Thomas Residence', 'Mid-Century Modern', 'Commercial Projects'];

const projects = [
  {
    id: 1,
    title: 'Saint Thomas Master Bathroom',
    location: 'Saint Thomas, USVI',
    category: 'Saint Thomas Residence',
    image: 'https://st.hzcdn.com/fimgs/1f319fb8044197b4_9586-w800-h600-b0-p0---bathroom.jpg'
  },
  {
    id: 2,
    title: 'Saint Thomas Outdoor Dining',
    location: 'Saint Thomas, USVI',
    category: 'Saint Thomas Residence',
    image: 'https://st.hzcdn.com/fimgs/2b9157e3044197c4_0278-w800-h600-b0-p0---patio.jpg'
  },
  {
    id: 3,
    title: 'Saint Thomas Guest Bathroom',
    location: 'Saint Thomas, USVI',
    category: 'Saint Thomas Residence',
    image: 'https://st.hzcdn.com/fimgs/7941fcaf044197d4_9672-w800-h600-b0-p0---bathroom.jpg'
  },
  {
    id: 4,
    title: 'Saint Thomas Infinity Pool',
    location: 'Saint Thomas, USVI',
    category: 'Saint Thomas Residence',
    image: 'https://st.hzcdn.com/fimgs/9e21b34c04419801_9830-w800-h600-b0-p0---pool.jpg'
  },
  {
    id: 5,
    title: 'Saint Thomas Pool Deck',
    location: 'Saint Thomas, USVI',
    category: 'Saint Thomas Residence',
    image: 'https://st.hzcdn.com/fimgs/c3412b8304419806_0358-w800-h600-b0-p0---pool.jpg'
  },
  {
    id: 6,
    title: 'Saint Thomas Patio',
    location: 'Saint Thomas, USVI',
    category: 'Saint Thomas Residence',
    image: 'https://st.hzcdn.com/fimgs/dba1581b04419809_0405-w800-h600-b0-p0---patio.jpg'
  },
  {
    id: 7,
    title: 'Lakefront Traditional Home',
    location: 'Elk Rapids, Michigan',
    category: 'Lakefront Homes',
    image: 'https://st.hzcdn.com/fimgs/e46143b906a13316_0407-w800-h600-b0-p0---.jpg'
  },
  {
    id: 8,
    title: 'Lakefront Home Exterior',
    location: 'Lake Michigan',
    category: 'Lakefront Homes',
    image: 'https://st.hzcdn.com/fimgs/287126c707c05cdd_1023-w800-h600-b2-p0--.jpg'
  },
  {
    id: 9,
    title: 'Mid-Century Modern Remodel',
    location: 'Sparta, Michigan',
    category: 'Mid-Century Modern',
    image: 'https://st.hzcdn.com/fimgs/b9113e6e0514549b_9206-w800-h600-b0-p0---.jpg'
  },
  {
    id: 10,
    title: 'Custom Furniture Bathroom',
    location: 'Grand Rapids, Michigan',
    category: 'Lakefront Homes',
    image: 'https://st.hzcdn.com/fimgs/3c4170670873f84a_0403-w800-h600-b0-p0---.jpg'
  },
  {
    id: 11,
    title: 'Complete Design with Window Treatments',
    location: 'Grand Rapids, Michigan',
    category: 'Lakefront Homes',
    image: 'https://st.hzcdn.com/fimgs/b23163cb092342b6_8573-w800-h600-b0-p0---.jpg'
  },
  {
    id: 12,
    title: 'Art Advisory & Curation',
    location: 'Grand Rapids, Michigan',
    category: 'Commercial Projects',
    image: 'https://st.hzcdn.com/fimgs/1f213afd063e8554_7680-w800-h600-b0-p0---.jpg'
  }
];

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const filteredProjects = activeCategory === 'All'
    ? projects
    : projects.filter(project => project.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-serif text-5xl md:text-6xl text-gray-900 mb-6">Our Portfolio</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our curated collection of thoughtfully designed spaces, from lakefront retreats to sophisticated commercial environments.
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="pb-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category
                    ? 'bg-amber-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="pb-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <div key={project.id} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-lg mb-4 w-full h-96">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-500"></div>
                </div>
                <h3 className="font-serif text-2xl text-gray-900 mb-1">{project.title}</h3>
                <p className="text-gray-600">{project.location}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-amber-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-gray-900 mb-6">
            Ready to Transform Your Space?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Let's discuss how we can bring your vision to life with thoughtful, sophisticated design.
          </p>
          <a
            href="/contact"
            className="inline-block bg-amber-600 text-white px-8 py-4 rounded-full font-medium hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Your Project
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
